import { gql } from '@src/lib/gql'

export const CLAIM_CLARITY_ADVISOR_IMPORT = gql`
  mutation ClaimClarityAdvisorImport($input: ClaimClarityAdvisorImportInput!) {
    claimClarityAdvisorImport(input: $input) {
      import {
        handle
        canonicalScreenName
        claimStatus
        expert {
          expertId
          fullName
          bio
          screenName
        }
      }
      advisorProfile {
        id
        advisorProfileId
        statusKey
        isApproved
        headline
        categoryKeys
        skillTagTitles
      }
      linkedAccount {
        id
        app
        externalUserId
      }
    }
  }
`
